import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { Box, Typography, Divider } from '@mui/material';
import React__default, { useMemo } from 'react';
import ZigPriceLabel from '../../display/ZigPriceLabel/index.js';

var DEFAULT_ITEMS = {
    balance: "Available:",
    min: "Min:",
    max: "Max:",
};
var extractItem = function (item, defaultValue, defaultLabel) {
    var _a, _b, _c, _d;
    if (item === false)
        return null;
    if (React__default.isValidElement(item))
        return item;
    if (typeof item === "object") {
        return {
            value: (_a = item.value) !== null && _a !== void 0 ? _a : defaultValue,
            label: (_c = (_b = item.label) !== null && _b !== void 0 ? _b : defaultLabel) !== null && _c !== void 0 ? _c : "",
        };
    }
    else {
        if (!defaultValue)
            return null;
        return { value: defaultValue, label: (_d = item !== null && item !== void 0 ? item : defaultLabel) !== null && _d !== void 0 ? _d : "" };
    }
};
var InputExtraInfo = function (props) {
    var balance = props.balance, min = props.min, max = props.max, coin = props.coin, _a = props.extraInfo, extraInfo = _a === void 0 ? {} : _a;
    var _b = extraInfo.wrapExtraInfo, wrapExtraInfo = _b === void 0 ? 2 : _b;
    var items = useMemo(function () {
        var itemsList = Object.keys(DEFAULT_ITEMS).map(function (key) {
            var validKey = key;
            var infoItem = extraInfo[validKey];
            return extractItem(infoItem, props[key], DEFAULT_ITEMS[validKey]);
        });
        if (extraInfo.others) {
            itemsList = itemsList.concat(extraInfo.others.map(function (item) { return extractItem(item); }));
        }
        return itemsList.filter(Boolean);
    }, [balance, min, max, coin, extraInfo]);
    var displayInRow = typeof wrapExtraInfo === "number" ? (items === null || items === void 0 ? void 0 : items.length) <= wrapExtraInfo : !wrapExtraInfo;
    return (React__default.createElement(Box, { display: "flex", flexWrap: "wrap", flexDirection: displayInRow ? "row" : "column", gap: "5px", alignItems: displayInRow ? "center" : "flex-start", justifyContent: displayInRow ? "center" : "flex-start", id: props.id }, items.map(function (item, i) { return (React__default.createElement(React__default.Fragment, { key: i },
        React__default.isValidElement(item) ? (item) : (React__default.createElement(Typography, { variant: "body2", id: props.id &&
                "".concat(props.id, "-").concat(item.label
                    .toLowerCase()
                    .replace(/[\s.:,%]/g, "")) },
            item.label,
            "\u00A0",
            React__default.createElement(ZigPriceLabel, __assign({ id: props.id && "".concat(props.id, "-value-").concat(item.label), value: item.value, coin: coin, coinProps: { color: "neutral100" }, color: "neutral100", variant: "body2", fontWeight: "regular" }, extraInfo.amountProps)))),
        displayInRow && i < items.length - 1 && (React__default.createElement(Divider, { id: props.id && "".concat(props.id, "-divider"), orientation: "vertical", sx: { borderColor: "neutral600", m: "1px 7px" }, flexItem: true })))); })));
};

export { InputExtraInfo };
